import OnlineAppComponent from "../lib/online_app_component";
import {requestNavToggle} from "../online_app/instances/state_machine/actions/helpers/nav_helpers";

export const OnlineAppNavTogglerButtonConfig = {
    componentTypeKey: 'OnlineAppNavTogglerButton',
    baseHtmlClass: 'online_app__main__nav_toggler_button',
    selector: '.online_app__main__nav_toggler_button',
};

/**
 * The web online-app's host control that opens the nav — the counterpart to the native
 * apps' map-screen menu button (iOS `MapViewController` hamburger, Android `MapFragment`
 * `button_menu`). It sits over the map (outside the nav webview) and, exactly like native,
 * REQUESTS a nav toggle rather than mutating nav state directly: it dispatches the inbound
 * intent event (`OnlineAppNav-toggleRequested`) that `nav.js` listens for on `window`. The
 * Nav webview remains the sole owner of open/closed state — it persists `navOpen` and emits
 * `OnlineAppNav-open`/`-close`, which `online_app_nav.js` reflects onto this surface.
 *
 * Because the button lives under the nav panel in z-order, it is covered once the nav opens;
 * it therefore functions as an OPEN affordance (closing is done from the nav's own in-pane
 * controls — the "Show Map" nav-bar button and the secondary-pane "Map" link), mirroring
 * native. We also hide it (`--hidden`) while the nav is open so it isn't a live, focusable
 * target behind the panel.
 */
export class OnlineAppNavTogglerButton extends OnlineAppComponent {

    static get config() {
        return OnlineAppNavTogglerButtonConfig;
    }

    constructor(id_or_element, onlineApp) {
        super(id_or_element, onlineApp, OnlineAppNavTogglerButtonConfig);
        if (!this.element) {
            return;
        }
        // Own-element listener — discarded with the element, so no onDestroy registration needed.
        this.element.addEventListener('click', this.handleClick.bind(this));
        this.render();
    }

    handleClick() {
        // Host request via the inbound intent contract — the online_app's canonical requester
        // (dispatches OnlineAppNav-toggleRequested at `window`, the same channel native uses via
        // WebViewRegistry.broadcastNavIntent). `nav.js` (the sole owner) listens there, toggles,
        // persists, and emits the outbound OnlineAppNav-open/-close that this surface reflects.
        requestNavToggle();
    }

    isNavOpen() {
        return !!this.readState('navOpen');
    }

    render() {
        this.conditionallySetHtmlClassState(this.isNavOpen(), 'hidden');
    }

}

export function getNavTogglerButton(element, onlineApp) {
    if (!element) return null;
    return new OnlineAppNavTogglerButton(element, onlineApp);
}
